import LandmarkRenderer from '../layouts/landmark_renderer';
import {
  CELL_SIZE
} from '../layouts/render_properties';
import { fabric } from 'fabric';


// major differences between this and default renderer are setupEventListeners is not called and
// the addition of the selectable and evented traits set to false
export default class LayoutFilterLandmarkRenderer extends LandmarkRenderer {
  async renderSVG() {
    const response = await fetch(this.landmark.svgURL);
    fabric.loadSVGFromString(await response.text(), (objects, options) => {
      const obj = fabric.util.groupSVGElements(objects, options);
      this.svg = obj;
      const { width, height } = obj;
      const scaleX = (this.landmark.width * CELL_SIZE) / width;
      const scaleY = (this.landmark.height * CELL_SIZE) / height;
      this.label = this.renderLabel(this.landmark.label);
      obj.set({ scaleX: scaleX, scaleY: scaleY, originX: 'center', originY: 'center', opacity: 0.8 });
      this.renderedElement = new fabric.Group([this.label, this.svg], {
        left: this.landmark.topLeftX * CELL_SIZE,
        top: this.landmark.topLeftY * CELL_SIZE,
        angle: this.landmark.rotation,
        selectable: false,
        evented: false
      });
      this.canvas.add(this.renderedElement);
      this.canvas.sendToBack(this.renderedElement);
    });
  }
}
